import { Injectable } from '@angular/core';
import { Action } from '@ngrx/store';
import { ParamInfo } from '../../core/index.model';

export const CREATE_PARAMETER = 'Parameter_Create';
export const CLEAR_PARAMETER = 'Parameter_Clear';
export const UPDATE_PARAMETER = 'Parameter_Update';

export class CreateParameter implements Action{
    readonly type = CREATE_PARAMETER;

    constructor(public payload: ParamInfo[]){}
}

export class UpdateParameter implements Action {
    readonly type = UPDATE_PARAMETER;

    constructor(public payload: ParamInfo[]) { }
}

export class ClearParameter implements Action
{
    readonly type = CLEAR_PARAMETER;

    constructor(){}
}

export type Actions = CreateParameter | UpdateParameter | ClearParameter ;


// WEBPACK FOOTER //
// D:/NewPhoenixScrum/PhoenixScrum/Main/CitizenSevicesEx/CSClient/CSClient/client/app/statemanagement/action/parameter.actions.ts